import React from "react";
import { Dialog } from "primereact/dialog";
import Buttonc from "../../../stories/common/button";
import styles from "./index.module.scss";
import { useToast } from "../../../stories/common/toast/toast";
import { useDeleteNotes } from "../../../hooks/react-query/investor-dashboard/useDeleteNotes";

interface DeleteNotesDialogProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  item?: any;
}

const DeleteNotesDialog: React.FC<DeleteNotesDialogProps> = ({
  visible,
  setVisible,
  item
}) => {
  const { showSuccess }: any = useToast();
  const deleteNotesMutation = useDeleteNotes(
    (data) => {
      showSuccess("success", "Notes Deleted Successfully.");
      console.log("data", data);
      setVisible(false);
    },
    (error) => {
      console.log("error", error);
      setVisible(false);
    }
  );

  return (
    <Dialog
      visible={visible}
      closable={true}
      closeOnEscape={true}
      header={<span className={styles.header}></span>}
      dismissableMask={true}
      onHide={() => setVisible(false)}
      className={styles.dialog}
      maskClassName={styles.dialogMask}
      draggable={false}
      resizable={false}
    >
      <div className={styles.title}>Delete Note</div>
      <div className={styles.subTitle}>Are you sure you want to delete this note?</div>
      <div className={styles.btnWrap}>
        <Buttonc
          btnType="border"
          type="submit"
          tabIndex={7}
          btnWrapClassName={styles.btnWrapClass}
          className={styles.cancelBtn}
          label={"Cancel"}
          disabled={deleteNotesMutation.isPending}
          onClick={() => {
            setVisible(false);
          }}
        />
        <Buttonc
          type="submit"
          btnWrapClassName={styles.btnWrapClass}
          tabIndex={7}
          label={"Delete"}
          loading={deleteNotesMutation.isPending}
          className={styles.subBtn}
          onClick={() => {
            deleteNotesMutation.mutate(item?.id);
          }}
        />
      </div>
    </Dialog>
  );
};

export default DeleteNotesDialog;
